import type { HealthBehaviour } from "@healthos/shared";
import { BowlFood, Heart, type Icon, Moon, PersonSimpleWalk, Wind } from "@phosphor-icons/react";

export interface MicrostepBehaviourVisual {
  color: string;
  Icon: Icon;
}

export const MICROSTEP_BEHAVIOUR_VISUALS = {
  sleep: { color: "var(--color-ambient-sleep)", Icon: Moon },
  food: { color: "var(--color-ambient-energy)", Icon: BowlFood },
  movement: { color: "var(--color-teal-400)", Icon: PersonSimpleWalk },
  stress: { color: "var(--color-ambient-calm)", Icon: Wind },
  connection: { color: "var(--color-ambient-heart)", Icon: Heart },
} satisfies Record<HealthBehaviour, MicrostepBehaviourVisual>;
